export default "__VITE_PUBLIC_ASSET__6786bffb__"